'use client';
import React from "react";

// Icons
import { IoClose } from "react-icons/io5";

// Actions
import $actions from "@actions";

// Store
import useStore from "@store";


export default function Modal() {
    const $state = useStore.getState();
    const { children, onClose, className = '' } = $state?.global?.modal || {};

    // ⚠️ Heads up! The following useEffect disables the body scroll when the modal is open.
    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, []);


    const handleClose =  () => {
        if (onClose) onClose();
        $actions.global.modal(null);
    }

    return (
        <div role="modal" className={`fixed flex flex-row items-start justify-center py-12 inset-0 w-full h-screen bg-black/60 z-[999] px-8`} style={{ height: `${document.body.scrollHeight}px` }}>
            <div className={`relative flex flex-col p-2 md:p-8 max-w-full bg-white max-h-[91vh] rounded-md shadow-black shadow-lg ${className}`}>
                <button onClick={handleClose} className={`flex cursor-pointer flex-row items-center shadow-[inset_0px_-5px_1px_#8c2524] hover:shadow-none justify-center rounded-full size-14 bg-gradient-to-b text-white hover:translate-y-[3px] from-[#efb426] to-[#ff7600] border-4 border-white absolute -top-5 -right-5 z-[999999]`}>
                    <IoClose className="text-3xl"/>
                </button>
                <div className={`overflow-x-hidden overflow-y-auto !scrollbar-hide`}>
                    {children}
                </div>
            </div>
        </div>
    )
}